 export const  formatImagePath = (path?: string): string => {
  if (!path) {
    return "assets/default.png";
  }

  if (path.startsWith("/")) {
    return path.substring(1);
  }

  return path;
}
